import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// ─────────────────────────────────────────────────────────────────────────────
// MENU DATA WITH CONTEXT-AWARE, RELATED ICONS
// ─────────────────────────────────────────────────────────────────────────────
const menuData = [
  {
    section: "DASHBOARDS",
    items: [
      {
        name: "Dashboards",
        icon: (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard",
      },
    ],
  },
  {
    section: "DISHES & MANAGEMENT ",
    items: [
      {
        name: "Menu",
        icon: (
          // BookOpen / Menu Book Icon
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
            <path d="M7 2v20" />
            <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/MenuMaster",
      },
      {
        name: "Campaigns",
        icon: (
          // Megaphone Icon (Perfect for promotions)
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 11l18-5v12L3 14v-3z" />
            <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/Campaigns",
      },
      {
        name: "OrdersList",
        icon: (
          // Shopping Bag Icon (Standard for food/orders)
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
            <path d="M3 6h18" />
            <path d="M16 10a4 4 0 0 1-8 0" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/OrdersList",
      },
      {
        name: "EarningsDashboard",
        icon: (
          // Bar Chart Icon (Better visual for earnings)
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" x2="12" y1="20" y2="10" />
            <line x1="18" x2="18" y1="20" y2="4" />
            <line x1="6" x2="6" y1="20" y2="16" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/EarningsDashboard",
      },
      {
        name: "Menu Update",
        icon: (
          // File Edit Icon
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/MenuUpdate",
      },
      {
        name: "MOU Agreement",
        icon: (
          // FileCheck Icon (Document with a signature/checkmark)
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
            <path d="M14 2v4a2 2 0 0 0 2 2h4" />
            <path d="m9 15 2 2 4-4" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/MOUAgreement",
      },
      {
        name: "Address",
        icon: (
          // MapPin Icon (Perfect for location/address)
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/EditAddress",
      },
      {
        name: "Help & Support",
        icon: (
          // HelpCircle Icon (Standard for help/support)
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/HelpSupport",
      },
      {
        name: "Support Ticket",
        icon: (
          // Ticket Icon (Perfect for ticketing systems)
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
            <path d="M13 5v2" />
            <path d="M13 17v2" />
            <path d="M13 11v2" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard/SupportTicket",
      },
    ],
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// PREMIUM UTILITY ICONS
// ─────────────────────────────────────────────────────────────────────────────
const SunIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

const MoonIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const CollapseIcon = ({ collapsed }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{
    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
  }}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ProfileIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// ORANGE THEME CONFIGURATION (Matching ZaptoDoor Logo Colors)
// ─────────────────────────────────────────────────────────────────────────────
const styles = {
  dark: {
    sidebar: { 
      background: "linear-gradient(180deg, #0f172a 0%, #1e1b4b 100%)",
      borderRight: "1px solid rgba(249, 115, 22, 0.15)" 
    },
    section: { color: "#94a3b8" },
    item: { color: "#cbd5e1" },
    itemHover: { 
      background: "rgba(249, 115, 22, 0.12)", 
      color: "#fdba74" 
    },
    itemActive: { 
      background: "linear-gradient(90deg, rgba(249, 115, 22, 0.2) 0%, rgba(251, 146, 60, 0.1) 100%)", 
      color: "#fdba74",
    },
    activeBar: { 
      background: "linear-gradient(180deg, #f97316 0%, #fb923c 100%)", 
      boxShadow: "0 0 12px rgba(249, 115, 22, 0.6)"
    },
    toggle: { background: "rgba(255,255,255,0.05)", color: "#94a3b8" },
    toggleHover: { background: "rgba(249, 115, 22, 0.15)", color: "#fdba74" },
    actionBtn: { color: "#94a3b8" },
    actionBtnHover: { background: "rgba(249, 115, 22, 0.15)", color: "#fdba74" },
    collapseBtn: { background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: "#94a3b8" },
    collapseBtnHover: { background: "rgba(249, 115, 22, 0.15)", color: "#fdba74", borderColor: "rgba(249, 115, 22, 0.3)" },
  },
  light: {
    sidebar: { 
      background: "#ffffff", 
      borderRight: "1px solid #e2e8f0" 
    },
    section: { color: "#94a3b8" },
    item: { color: "#64748b" },
    itemHover: { 
      background: "rgba(249, 115, 22, 0.08)",
      color: "#ea580c"
    },
    itemActive: { 
      background: "linear-gradient(90deg, rgba(249, 115, 22, 0.12) 0%, rgba(251, 146, 60, 0.08) 100%)", 
      color: "#ea580c",
    },
    activeBar: { 
      background: "linear-gradient(180deg, #f97316 0%, #fb923c 100%)", 
      boxShadow: "0 0 8px rgba(249, 115, 22, 0.4)"
    },
    toggle: { background: "#f1f5f9", color: "#64748b" },
    toggleHover: { background: "rgba(249, 115, 22, 0.1)", color: "#ea580c" },
    actionBtn: { color: "#64748b" },
    actionBtnHover: { background: "rgba(249, 115, 22, 0.1)", color: "#ea580c" },
    collapseBtn: { background: "#f8fafc", border: "1px solid #e2e8f0", color: "#64748b" },
    collapseBtnHover: { background: "rgba(249, 115, 22, 0.1)", color: "#ea580c", borderColor: "rgba(249, 115, 22, 0.3)" },
  },
};

const Sidebar = ({
  activeItem = "Dashboards",
  setActiveItem,
  isSidebarCollapsed = false,
  setIsSidebarCollapsed,
  isDark = true,
  setIsDark,
  onMobileClose,
  onProfileClick,
}) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredToggle, setHoveredToggle] = useState(false);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [hoveredCollapse, setHoveredCollapse] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const theme = isDark ? styles.dark : styles.light;

  const handleNavigation = (path, name) => {
    setActiveItem(name);
    if (path) navigate(path);
    if (isMobile && onMobileClose) onMobileClose();
  };

  const handleProfileClick = () => {
    navigate("/dashboard/StoreProfile");
    if (onProfileClick) onProfileClick();
    if (isMobile && onMobileClose) onMobileClose();
  };

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <div
        style={{
          width: isSidebarCollapsed && !isMobile ? "72px" : isMobile ? "280px" : "260px",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          transition: "width 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
          overflow: "hidden",
          position: "relative",
          flexShrink: 0,
          boxShadow: isDark ? "4px 0 24px rgba(0,0,0,0.4)" : "4px 0 24px rgba(0,0,0,0.04)",
          ...theme.sidebar,
        }}
      >
        {/* Custom Orange Scrollbar Styles */}
        <style>{`
          .sidebar-scroll::-webkit-scrollbar { width: 4px; }
          .sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
          .sidebar-scroll::-webkit-scrollbar-thumb { background: ${isDark ? 'rgba(249, 115, 22, 0.3)' : 'rgba(249, 115, 22, 0.2)'}; border-radius: 4px; }
          .sidebar-scroll::-webkit-scrollbar-thumb:hover { background: ${isDark ? 'rgba(249, 115, 22, 0.5)' : 'rgba(249, 115, 22, 0.4)'}; }
        `}</style>

        {/* Brand logo */}
        <div style={{
          padding: isSidebarCollapsed && !isMobile ? "20px 0" : "20px 20px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          justifyContent: (isSidebarCollapsed && !isMobile) ? "center" : "flex-start",
          borderBottom: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid #f1f5f9",
          flexShrink: 0,
        }}>
          <div style={{
            width: (isSidebarCollapsed && !isMobile) ? "40px" : "45px",
            height: (isSidebarCollapsed && !isMobile) ? "40px" : "45px",
            borderRadius: "10px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            background: isDark ? "rgba(255,255,255,0.05)" : "transparent",
          }}>
            <img
              src="/Zaptodoor.png"
              alt="ZaptoDoor"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          {(!isSidebarCollapsed || isMobile) && (
            <span style={{ 
              fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif", 
              fontWeight: 800, 
              fontSize: "18px", 
              letterSpacing: "-0.5px", 
              color: isDark ? "#f8fafc" : "#0f172a"
            }}>
              Zapto<span style={{
                background: "linear-gradient(135deg, #f97316 0%, #fb923c 50%, #f59e0b 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}>Door</span>
            </span>
          )}
        </div>

        {/* Scrollable Menu */}
        <div className="sidebar-scroll" style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          padding: "16px 0",
        }}>
          {menuData.map((group) => (
            <div key={group.section} style={{ marginBottom: "8px" }}>
              {(!isSidebarCollapsed || isMobile) && (
                <div style={{ 
                  padding: "8px 24px 8px", 
                  fontSize: "11px", 
                  fontWeight: 700, 
                  letterSpacing: "1.5px", 
                  textTransform: "uppercase", 
                  ...theme.section 
                }}>
                  {group.section}
                </div>
              )}
              {(isSidebarCollapsed && !isMobile) && <div style={{ height: "12px" }} />}

              {group.items.map((item) => {
                const active = activeItem === item.name;
                const hovered = hoveredItem === item.name;

                let iconColor = theme.item.color;
                if (active) {
                  iconColor = isDark ? "#fdba74" : "#ea580c";
                } else if (hovered) {
                  iconColor = isDark ? "#fdba74" : "#ea580c";
                }

                return (
                  <div key={item.name}>
                    <div
                      onClick={() => handleNavigation(item.path, item.name)}
                      onMouseEnter={() => setHoveredItem(item.name)}
                      onMouseLeave={() => setHoveredItem(null)}
                      title={(isSidebarCollapsed && !isMobile) ? item.name : ""}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "14px",
                        padding: (isSidebarCollapsed && !isMobile) ? "12px 0" : "11px 20px",
                        justifyContent: (isSidebarCollapsed && !isMobile) ? "center" : "flex-start",
                        cursor: "pointer",
                        position: "relative",
                        borderRadius: (isSidebarCollapsed && !isMobile) ? "12px" : "0 12px 12px 0",
                        margin: (isSidebarCollapsed && !isMobile) ? "4px 8px" : "2px 0 2px 8px",
                        transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                        ...(active ? theme.itemActive : hovered ? theme.itemHover : { color: theme.item.color, background: "transparent" }),
                      }}
                    >
                      {active && (
                        <div style={{ 
                          position: "absolute", 
                          left: 0, 
                          top: "50%", 
                          transform: "translateY(-50%)", 
                          width: "3px", 
                          height: "60%", 
                          borderRadius: "0 4px 4px 0", 
                          ...theme.activeBar,
                        }} />
                      )}
                      <span style={{ 
                        flexShrink: 0, 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center",
                        transition: "all 0.2s ease",
                        transform: hovered ? "scale(1.1)" : "scale(1)",
                        color: iconColor,
                      }}>
                        {item.icon}
                      </span>
                      {(!isSidebarCollapsed || isMobile) && (
                        <span style={{ 
                          flex: 1, 
                          fontSize: "14px", 
                          fontWeight: active ? 600 : 500, 
                          whiteSpace: "nowrap", 
                          overflow: "hidden", 
                          textOverflow: "ellipsis",
                          letterSpacing: "0.2px"
                        }}>
                          {item.name}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        {/* Bottom Controls */}
        <div style={{
          padding: (isSidebarCollapsed && !isMobile) ? "16px 0" : "16px 16px",
          borderTop: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid #f1f5f9",
          display: "flex",
          flexDirection: (isSidebarCollapsed && !isMobile) ? "column" : "row",
          alignItems: "center",
          gap: (isSidebarCollapsed && !isMobile) ? "8px" : "8px",
          justifyContent: (isSidebarCollapsed && !isMobile) ? "center" : "space-between",
          flexShrink: 0,
        }}>
          {/* Theme Toggle */}
          <button
            onClick={() => setIsDark(!isDark)}
            onMouseEnter={() => setHoveredToggle(true)}
            onMouseLeave={() => setHoveredToggle(false)}
            title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: (isSidebarCollapsed && !isMobile) ? "10px" : "8px 14px",
              borderRadius: "10px",
              border: "none",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 600,
              transition: "all 0.2s ease",
              width: (isSidebarCollapsed && !isMobile) ? "40px" : "auto",
              justifyContent: (isSidebarCollapsed && !isMobile) ? "center" : "flex-start",
              ...(hoveredToggle ? theme.toggleHover : theme.toggle),
            }}
          >
            {isDark ? <SunIcon /> : <MoonIcon />}
            {(!isSidebarCollapsed || isMobile) && (
              <span>{isDark ? "Light" : "Dark"}</span>
            )}
          </button>

          {/* Action Buttons Group */}
          {(!isSidebarCollapsed || isMobile) && (
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              {/* Profile Button */}
              <button
                onClick={handleProfileClick}
                onMouseEnter={() => setHoveredAction("profile")}
                onMouseLeave={() => setHoveredAction(null)}
                title="Profile Settings"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "8px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease",
                  color: hoveredAction === "profile" ? theme.actionBtnHover.color : theme.actionBtn.color,
                  background: hoveredAction === "profile" ? theme.actionBtnHover.background : "transparent",
                }}
              >
                <ProfileIcon />
              </button>
            </div>
          )}

          {/* Collapse Button */}
          {!isMobile && (
            <button 
              onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)} 
              title={isSidebarCollapsed ? "Expand Sidebar" : "Collapse Sidebar"} 
              onMouseEnter={() => setHoveredCollapse(true)}
              onMouseLeave={() => setHoveredCollapse(false)}
              style={{ 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center", 
                width: "32px", 
                height: "32px", 
                borderRadius: "10px", 
                cursor: "pointer", 
                transition: "all 0.2s ease", 
                border: "none",
                ...(hoveredCollapse ? theme.collapseBtnHover : theme.collapseBtn),
              }}
            >
              <CollapseIcon collapsed={isSidebarCollapsed} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
